import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'The Nightstand Reset Checklist',
  subtitle: 'Set up your bedroom for spine recovery in 5 minutes.',
  image: 'https://cdn.magicpatterns.com/uploads/a9Gf7LArKQd4mkG7Ub3ScB/Bonus_1_Image_Nighstand_Reset_Checklist.png',
  body: ['Your bedroom environment plays a massive role in how your nervous system processes pain. If your nightstand is cluttered, your brain stays in a low-level state of alertness.', 'This simple, actionable checklist transforms your immediate sleeping area into a dedicated healing zone, ensuring that when you lie down, your body gets the exact biological cues it needs to release tension and prepare for deep, restorative sleep.'],
  bullets: ['Optimal nightstand layout for spine support', 'The 3 essential items every back-pain sufferer needs within reach', 'Lighting setup that calms the nervous system', 'What to remove from your bedroom tonight', 'The perfect water-glass-and-pen placement for the morning protocol']
}, {
  num: 2,
  title: 'The 3-Minute Bed Exit Guide',
  subtitle: 'Optimizing Your Morning Mobility for Health & Vitality.',
  image: 'https://cdn.magicpatterns.com/uploads/9tAT8ofjRa4t2m2wMTQWYP/Bonus_2_Image_3_Minute_Bed_Exit.png',
  body: ['How you get out of bed in the morning dictates how your spine will feel for the rest of the day. A sudden, jarring movement can instantly undo the healing your body achieved overnight.', 'This 3-minute visual guide walks you through the exact, biomechanically safe sequence to transition from sleeping to standing. It gently wakes up your stabilizing muscles, decompresses your discs, and sets a pain-free foundation for your entire day.'],
  bullets: ['The safe wake-up sequence to prevent morning spasms', "The 'roll-to-side' technique that protects your lumbar discs", 'The seated activation to engage your core before standing', 'The first standing posture to align your pelvis', 'A gentle morning mobility flow to lock in the relief']
}, {
  num: 3,
  title: 'The 7-Day Nightly Consistency Tracker',
  subtitle: 'A premium productivity & wellness guide to lock in your nightly routine.',
  image: 'https://cdn.magicpatterns.com/uploads/5Mk4nBmKfuj2JSm6EZAJtv/Bonus_3_Image_7_Day_Consistency_Tracker_(2).png',
  body: ["The secret to permanently ending nighttime back pain isn't just doing the protocol once—it's doing it consistently until your nervous system establishes a new, pain-free baseline.", "This beautifully designed, printable tracker uses proven habit-loop psychology to keep you accountable. By visually tracking your progress, you'll stay motivated, clearly see your pain scores dropping, and turn the 11PM Spine Reset into an automatic, effortless part of your evening."],
  bullets: ['Daily pain score tracking to visualize your improvement', 'Sleep-quality log to connect the protocol to your rest', 'Mood metrics to monitor your nervous system regulation', 'A simple nightly checklist to ensure you never miss a step', 'A weekly review pattern to celebrate your wins and stay on track']
}];
export function BonusCards() {
  return <section className="bg-cream py-[80px] px-6" data-id="element-20">
      <div className="max-w-[880px] mx-auto" data-id="element-21">
        <h2 className="text-teal-500 uppercase text-[11px] tracking-[0.15em] font-bold text-center mb-4" data-id="element-22">
          WHAT'S INCLUDED FREE TODAY
        </h2>
        <p className="text-center font-serif text-navy-800 text-2xl md:text-3xl mb-12" data-id="element-23">
          And when you order today, you also get...
        </p>

        <div className="space-y-8" data-id="element-24">
          {bonuses.map((bonus, i) => <motion.div key={bonus.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-navy-800/10 rounded-[16px] shadow-[0_4px_24px_rgba(0,0,0,0.06)] p-6 md:p-10" data-id="element-25">
              <div className="flex flex-wrap items-center justify-between gap-4 mb-6" data-id="element-26">
                <div className="bg-gold/15 border border-gold text-navy-800 font-bold text-[11px] uppercase px-3 py-1 rounded-full" data-id="element-27">
                  BONUS #{bonus.num}
                </div>
                <div className="bg-navy-800 text-white text-[11px] font-medium px-4 py-1.5 rounded-full" data-id="element-28">
                  Value: $27 — Yours FREE
                </div>
              </div>

              <div className="rounded-[10px] overflow-hidden mb-6 bg-navy-800 shadow-sm flex items-center justify-center" data-id="element-29">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto max-h-[520px] object-contain" data-id="element-30" />
              </div>

              <h3 className="font-serif text-navy-800 text-[26px] font-bold mb-2" data-id="element-31">
                {bonus.title}
              </h3>
              <p className="font-sans text-teal-500 text-[15px] font-medium mb-5" data-id="element-32">
                {bonus.subtitle}
              </p>

              <div className="space-y-4 mb-6" data-id="element-33">
                {bonus.body.map((p, idx) => <p key={idx} className="font-sans text-body text-[15px] leading-[1.7]" data-id="element-34">
                    {p}
                  </p>)}
              </div>

              <ul className="space-y-2 mb-6" data-id="element-35">
                {bonus.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2 text-navy-800 text-[14px] leading-[2] pl-2" data-id="element-36">
                    <Sparkles className="w-4 h-4 text-teal-400 shrink-0 mt-1.5" data-id="element-37" />
                    <span data-id="element-38">{bullet}</span>
                  </li>)}
              </ul>

              <div className="border-t border-black/10 border-dashed pt-5 flex items-center justify-between" data-id="element-39">
                <span className="text-gray-400 text-[13px] line-through" data-id="element-40">
                  Valued at $27
                </span>
                <span className="text-teal-500 font-bold text-[16px]" data-id="element-41">
                  Yours FREE today
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}